@if (hasFeedback$ | async) {
  <button mat-icon-button (click)="openFeedbackList()">
    <mat-icon fontIcon="flag" class="material-symbols-outlined feedback-icon">
    </mat-icon>
  </button>
}
